export const API_TYPE = {
  MKT: 'MKT',
  MKT_CMS: 'MKTCMS',
  MKT_CONNECT: 'MKTCONNECT',
  ECOM_CMS: 'ECOMCMS',
  ECOM: 'ECOM',
  CRM: 'CRM',
}
